import React from "react";
import ang from "../../images/right-angle.svg";

const capitalizeFirst = (text) => {
  if (!text) return "";
  return text.charAt(0).toUpperCase() + text.slice(1);
};

const Breadcrumb = ({ title, previousPage = null, hide = false }) => {
  return (
    <div className="adapter-single-links hub_breadcum">
      <ul>
        <li>
          <a href="/">
            Home
            <span>
              <img src={ang} alt="" />
            </span>
          </a>
        </li>

        {!hide && previousPage?.main_parent?.title && (
          <li>
            <a href={`/${previousPage?.main_parent?.slug}`}>
              {capitalizeFirst(previousPage?.main_parent?.title)}
              <span>
                <img src={ang} alt="" />
              </span>
            </a>
          </li>
        )}

        {!hide && previousPage?.title && (
          <li>
            <a href={`/${previousPage.slug}`}>
              {capitalizeFirst(previousPage.title)}
              <span>
                <img src={ang} alt="" />
              </span>
            </a>
          </li>
        )}

        <li className="active">
          <a>
             {capitalizeFirst(title)}
            <span>
              <img src={ang} alt="" />
            </span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Breadcrumb;